import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Tv } from "lucide-react";

export const OfferBar = () => (
  <Link
    to="/"
    data-testid="site-offer-bar"
    className="group block bg-[#0a1f44] text-white text-center text-sm px-4 py-2.5 hover:bg-[#123a7a] transition-colors"
  >
    <span className="inline-flex items-center gap-2 flex-wrap justify-center">
      <Tv className="w-4 h-4 text-[#3b9dff]" />
      <strong data-testid="offer-bar-tagline">TV sold, mounted, wires hidden, in one visit.</strong>
      <span data-testid="offer-bar-support" className="text-slate-300">We supply the TV and gear, mount it, hide the wires, and teach you the remote.</span>
      <span className="inline-flex items-center gap-1 font-bold text-[#3b9dff]">
        See the offer <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
      </span>
    </span>
  </Link>
);
